/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {AnalysisVO} from '@/valueObjects/AnalysisVO'

export default class ReportValidator {
    public static hasStaticField(analysis: AnalysisVO, field: string): boolean {
        if (analysis
            && analysis.hasOwnProperty('staticReport')
            && analysis.staticReport
            && analysis.staticReport.hasOwnProperty(field)
            && analysis.staticReport[field]) {
            return true
        }

        return false
    }

   public static hasDynamicField(analysis: AnalysisVO, field: string): boolean {
        if (analysis
            && analysis.hasOwnProperty('dynamicReport')
            && analysis.dynamicReport
            && analysis.dynamicReport.hasOwnProperty(field)
            && analysis.dynamicReport[field]) {
            return true
        }

        return false
    }
}
